/* Mystic Modesty — newsletter signup reveal (v3, 2026-07-12)
 *
 * ARCHITECTURE FIX (2026-07-12) — CRITICAL:
 * v1/v2 intercepted the submit (capture phase), showed WELCOME10 instantly and
 * re-POSTed the form via background fetch. Shopify's spam protection rejects
 * any /contact POST without its captcha token → HTTP 400 (verified live
 * 2026-07-12). Result: every reveal-path signup was silently LOST — customer
 * saw the code + "we'll email it", no contact was ever created.
 *
 * v3 pattern: DO NOT touch the submission. The native submit runs with
 * Shopify's captcha token (invisible for most humans; challenge page when
 * suspicious). Shopify redirects back with ?customer_posted=true + the form
 * anchor (browser lands scrolled to the footer form). On that load we swap
 * the form for the WELCOME10 reveal, persist the subscribed flag, and keep
 * suppressing the popup for known subscribers.
 *
 * Kept from the 2026-07-07 audit version: localStorage re-nag fix, popup
 * suppression (design-mode-safe), role="status" reveal, copy button,
 * chrome-hiding, try/catch storage.
 */
(function () {
  'use strict';
  try {
    var CODE = 'WELCOME10';
    var STORAGE_KEY = 'mm-newsletter-subscribed';

    function markSubscribed() {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) {}
    }
    function isSubscribed() {
      try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
    }

    // Subscribers should never be re-nagged by the popup. Never suppress in
    // the theme editor.
    function suppressPopupIfSubscribed() {
      try {
        if (window.Shopify && window.Shopify.designMode) return;
        if (!isSubscribed()) return;
        var popups = document.querySelectorAll('newsletter-popup');
        Array.prototype.forEach.call(popups, function (p) {
          if (p.parentNode) p.parentNode.removeChild(p);
        });
      } catch (e) {}
    }

    function buildReveal() {
      var el = document.createElement('div');
      el.className = 'mm-newsletter-success';
      el.setAttribute('data-mm-reveal', '');
      el.setAttribute('role', 'status');
      el.innerHTML =
        '<p class="mm-newsletter-success__heading">Welcome to the family.</p>' +
        '<p class="mm-newsletter-success__copy">Your 10% off code:</p>' +
        '<p class="mm-newsletter-success__code" data-mm-code>' + CODE + '</p>' +
        '<div class="mm-newsletter-success__actions">' +
          '<button type="button" class="mm-newsletter-success__copybtn" data-mm-copy>Copy code</button>' +
        '</div>' +
        '<p class="mm-newsletter-success__hint">We\'ve also emailed it to you. Use it at checkout.</p>';
      return el;
    }

    function wireCopy(reveal) {
      var copyBtn = reveal.querySelector('[data-mm-copy]');
      if (!copyBtn) return;
      copyBtn.addEventListener('click', function () {
        try {
          var done = function () {
            copyBtn.textContent = 'Copied!';
            setTimeout(function () { copyBtn.textContent = 'Copy code'; }, 1800);
          };
          if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(CODE).then(done);
          } else {
            var ta = document.createElement('textarea');
            ta.value = CODE;
            document.body.appendChild(ta);
            ta.select();
            document.execCommand('copy');
            document.body.removeChild(ta);
            done();
          }
        } catch (err) {}
      });
    }

    // Hide surrounding headings/subtext + any native success message so the
    // reveal is the single message in the block.
    function hideContextChrome(form, reveal) {
      try {
        var node = form.parentNode;
        for (var depth = 0; depth < 4 && node; depth++) {
          var hideMe = node.querySelectorAll(':scope > h1, :scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6, :scope > p, :scope > .form-status, :scope > [class*="success"]');
          if (hideMe && hideMe.length > 0) {
            for (var k = 0; k < hideMe.length; k++) {
              var h = hideMe[k];
              if (!h.contains(form) && !h.contains(reveal)) h.style.display = 'none';
            }
            break;
          }
          node = node.parentNode;
        }
      } catch (e) {}
    }

    function isNewsletterForm(f) {
      try {
        if (f.classList && f.classList.contains('newsletter-form')) return true;
        if (f.id && f.id.indexOf('newsletter-') === 0) return true;
        var emailInput = f.querySelector('input[name="contact[email]"]');
        var tagsInput = f.querySelector('input[name="contact[tags]"]');
        if (emailInput && tagsInput && /newsletter/i.test(tagsInput.value || '')) return true;
      } catch (e) {}
      return false;
    }

    // Success detection: Shopify redirects newsletter (form_type "customer")
    // posts back with ?customer_posted=true (+ the form's anchor, so the
    // browser lands scrolled to the footer form).
    function postedSuccessfully() {
      try { return /[?&]customer_posted=true\b/.test(window.location.search); } catch (e) { return false; }
    }

    function showRevealAt(form) {
      var parent = form.parentNode;
      if (!parent || parent.querySelector('[data-mm-reveal]')) return;
      var reveal = buildReveal();
      form.style.display = 'none';
      parent.insertBefore(reveal, form);
      hideContextChrome(form, reveal);
      wireCopy(reveal);
    }

    function init() {
      try {
        suppressPopupIfSubscribed();
        if (!postedSuccessfully()) return;

        // Just subscribed via the native flow: persist + suppress + reveal.
        markSubscribed();
        suppressPopupIfSubscribed();

        var forms = document.querySelectorAll('form');
        var target = null;
        Array.prototype.forEach.call(forms, function (f) {
          if (!target && isNewsletterForm(f) && !(f.closest && f.closest('newsletter-popup'))) target = f;
        });
        if (target) showRevealAt(target);
      } catch (e) {
        if (window.console && console.warn) console.warn('mm-newsletter-reveal:', e);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
    // In case something defers footer rendering
    setTimeout(init, 500);
    setTimeout(init, 2000);
  } catch (e) {
    if (window.console && console.warn) console.warn('mm-newsletter-reveal failed to init:', e);
  }
})();
